import { ReceiptGenerator } from "../../helpers/ReceiptGenerator";

export class ReceiptResponse {
    commonCssStyle!: string;
    receiptPages!: ReceiptPage[];

    constructor(value: any) {
        Object.assign(this, value);
    }

    async imageBase64(): Promise<string> {
        if (!this.receiptPages || this.receiptPages.length < 1) {
            return '';
        }

        const receiptCss = atob(this.commonCssStyle);
        const receiptPage = this.receiptPages[0];
        let receiptPageHtml = atob(receiptPage.content);

        if (receiptPageHtml.indexOf('<style>') !== -1) {
            receiptPageHtml = receiptPageHtml.replace(/<style>([\s\S]*?)<\/style>/, '<style>\n' + receiptCss + '\n</style>');
        }
        else if (receiptPageHtml.indexOf('</head>') !== -1) {
            receiptPageHtml = receiptPageHtml.replace('</head>', '<style>\n' + receiptCss + '\n</style></head>');
        }
        else {
            receiptPageHtml = '<style>\n' + receiptCss + '\n</style>\n' + receiptPageHtml;
        }

        return ReceiptGenerator.encodedImageFromHtml(this.clearHtml(receiptPageHtml), { stripFonts: true });
    }

    private clearHtml(htmlContent: string): string {
        let html = htmlContent;
        const clearHtmlRules = [
            { value: '"', replaceTo: '"' },
            { value: '\r', replaceTo: '' },
            { value: '\n', replaceTo: '' }
        ];

        for (var i = 0, len = clearHtmlRules.length; i < len; i++) {
            const rule = clearHtmlRules[i];
            html = html.replace(rule.value, rule.replaceTo);
        }

        return html;
    }
}

export interface ReceiptPage {
    name: string;
    content: string;
}
